export default {
    path: 'academic',
    name: 'academicForm',
    component(){
        return import('@/components/academic/AcademicForm.vue');
    },
    children: [
        {
            path: '',
            name: 'ConferenceList',
            component() {
                return import('@/components/academic/conference/ConferenceList.vue');
            }
        },
        {
            path:':id',
            name: 'ConferenceDetail',
            component() {
                return import('@/components/academic/conference/ConferenceDetail.vue');
            }
        },
        {
            path:'funding',
            name: 'FundingList',
            component() {
                return import('@/components/academic/funding/FundingList.vue');
            }
        },
        {
            path:'funding/:fundingId',
            name: 'FundingDetail',
            component() {
                return import('@/components/academic/funding/FundingDetail.vue');
            }
        },
        {
            path:'patent',
            name:'PatentList',
            component(){
                return import('@/components/academic/patent/PatentList.vue');
            }
        },
        {
            path:'patent/:patentId',
            name:'PatentDetail',
            component(){
                return import('@/components/academic/patent/PatentDetail.vue');
            }
        },
        {
            path:'techtrans',
            name:'TechtransList',
            component() {
                return import('@/components/academic/techtrans/TechtransList.vue');
            }
        },
        {
            path:'techtrans/:transferId',
            name:'TechtransDetail',
            component() {
                return import('@/components/academic/techtrans/TechtransDetail.vue');
            }
        },
        {
            path:'report',
            name:'ReportList',
            component() {
                return import('@/components/academic/report/ReportList.vue');
            }
        },
        {
            path:'report/:reportId',
            name:'ReportDetail',
            component() {
                return import('@/components/academic/report/ReportDetail.vue');
            }
        },

    ],
}